import { FaInstagram, FaFacebookF } from "react-icons/fa";
import logoNoxzi from "../../images/DA_NoxZi/Logo-bg-transparent-black.webp";
import { Link } from "react-router-dom";
import logoSavoiniaux from "../../images/DA_Savoinimaux/logo.webp";

export default function Footer() {
  const handleManageCookies = () => {
    if (window.openCookiePreferences) {
      window.openCookiePreferences();
    }
  };

  return (
    <footer className="border-t border-black/6 bg-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 lg:grid-cols-4 lg:px-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src={logoSavoiniaux}
              alt="Logo Savoinimaux"
              className="h-12 w-auto object-contain"
              loading="lazy"
            />
            <p className="text-lg font-semibold tracking-[0.35em] text-[#111111]">
              SAVOINIMAUX
            </p>
          </div>

          <p className="mt-4 max-w-md text-sm leading-7 text-gray-800">
            Association de protection animale en Savoie. Ensemble, offrons une seconde chance à ceux qui n'ont plus de voix.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.35em] text-black/45">
            Contact
          </p>
          <ul className="mt-4 space-y-3 text-sm text-black/60">
            <li>
              <a href="mailto:savoinimaux@gmail.com" target="_blank" rel="noreferrer">
                savoinimaux@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:+330644685253">06 44 68 52 53</a>
            </li>
            <li>Rumilly, France</li>
            <li>Association de protection animale</li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.35em] text-black/45">
            Réseaux
          </p>
          <div className="mt-4 flex gap-3">
           <a
            href="https://www.instagram.com/savoinimaux/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram de Savoinimaux"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-black/10 bg-white transition hover:bg-red-50"
          >
            <FaInstagram className="h-4 w-4 text-[#111111]" aria-hidden="true" />
          </a>

          <a
            href="https://www.facebook.com/Savoinimaux/"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook de Savoinimaux"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-black/10 bg-white transition hover:bg-red-50"
          >
            <FaFacebookF className="h-4 w-4 text-[#111111]" aria-hidden="true" />
          </a>
          </div>
        </div>
      </div>

      <div className="border-t border-black/6">
        <div className="mx-auto flex max-w-7xl flex-col gap-5 px-6 py-5 text-sm text-black/55 lg:px-10">
          <div className="flex flex-col items-start justify-between gap-4 lg:flex-row lg:items-center">
            <p>© 2013 - 2026 Savoinimaux — Tous droits réservés.</p>

            <a
              href="https://noxzi.fr"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3"
            >
              <span>Propulsé par</span>
              <img
                src={logoNoxzi}
                alt="Logo NoxZi"
                className="h-7 w-auto object-contain"
                loading="lazy"
              />
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-black/60">
            <Link
              to="/mentions-legales"
              className="transition hover:text-[#b3261e]"
            >
              Mentions légales
            </Link>

            <Link
              to="/cgu"
              className="transition hover:text-[#b3261e]"
            >
              CGU
            </Link>

            <Link
              to="/politique-de-confidentialite"
              className="transition hover:text-[#b3261e]"
            >
              Politique de confidentialité
            </Link>

            <Link
              to="/politique-cookies"
              className="transition hover:text-[#b3261e]"
            >
              Politique de cookies
            </Link>

            <button
              type="button"
              onClick={handleManageCookies}
              className="transition hover:text-[#b3261e]"
            >
              Gérer mes cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}